export const MAX_COLOURS = 15
const TAG_ICON_PREFIX = "assets/images/tags/tag-"
export const TAG_COLOURS: string[] = ['#e6194B', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#42d4f4', '#f032e6', '#469990', '#9A6324', '#000075', '#a9a9a9', '#000000', '#800000', '#bfef45', '#808000']

// each tag has one of the colours, and a matching icon; an index outside them wraps round rather than showing nothing
const colourIndex = (i:number) => Number.isInteger(i) ? ((i % TAG_COLOURS.length) + TAG_COLOURS.length) % TAG_COLOURS.length : 0

// the first colour no tag has yet; once all are used, they are shared in turn
export const nextTagIndex = (tagIndexes:number[]):number => {
    for (let i = 0; i < TAG_COLOURS.length; i++) {
        if (!tagIndexes.includes(i)) return i
    }
    return tagIndexes.length % TAG_COLOURS.length
}

export const getIconForTagIndex = (i:number):string => TAG_ICON_PREFIX + colourIndex(i) + '.png'

export const getColourStyleForTagIndex = (i:number):string => "color:" + TAG_COLOURS[colourIndex(i)] + ";"
